/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

jQuery(document).ready(function () {
  jQuery(".section--overflow").on("click", ".section-btn", function (e) {
    e.preventDefault();

    jQuery(this).closest(".section--overflow").toggleClass("in");

    if (jQuery(this).closest(".section--overflow").hasClass("in")) {
      jQuery(this).html("<span>Read less</span>");
    } else {
      jQuery(this).html("<span>Read more</span>");
    }
  });

  jQuery(document).on(
    "click",
    '[data-action="toggle-collapsible"]',
    function () {
      var parentCollapsible = jQuery(this).closest(".Collapsible");
      var collapsibleInner = parentCollapsible.find(".Collapsible__Inner");

      if (jQuery(this).attr("aria-expanded") === "false") {
        jQuery('[data-action="toggle-collapsible"]').attr(
          "aria-expanded",
          "false"
        );
        jQuery(".Collapsible__Inner").slideUp();

        jQuery(this).attr("aria-expanded", "true");
        collapsibleInner.slideDown();
      } else {
        jQuery(this).attr("aria-expanded", "false");
        collapsibleInner.slideUp();
      }
    }
  );

  // Quantity values
  jQuery(document).on(
    "click",
    '[data-action="increase-quantity"]',
    function (e) {
      e.preventDefault();
      var input_quantity = jQuery(this).parent().find("[data-quantity-input]");

      // Get its current value
      var currentVal = parseInt(input_quantity.val());
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment
        input_quantity.val(currentVal + 1).trigger("change");
      } else {
        // Otherwise put a 0 there
        input_quantity.val(1).trigger("change");
      }
    }
  );

  jQuery(document).on(
    "click",
    '[data-action="decrease-quantity"]',
    function (e) {
      e.preventDefault();
      var input_quantity = jQuery(this).parent().find("[data-quantity-input]");

      // Get its current value
      var currentVal = parseInt(input_quantity.val());
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        input_quantity.val(currentVal - 1).trigger("change");
      } else {
        // Otherwise put a 0 there
        input_quantity.val(1).trigger("change");
      }
    }
  );

  setTimeout(function () {
    if (jQuery(window).width() < 1024) {
      var heightSlide = jQuery(
        ".product-recommendations--section .flickity-slider"
      ).innerHeight();
      jQuery(".product-recommendations--section .flickity-viewport").height(
        heightSlide
      );

      jQuery(window).on("scroll resize", function () {
        var heightSlide = jQuery(
          ".product-recommendations--section .flickity-slider"
        ).innerHeight();
        jQuery(".product-recommendations--section .flickity-viewport").height(
          heightSlide
        );
      });
    }
  }, 1000);

  // jQuery("body").on("click", ".cart-checkout .btn-checkout", function (e) {
  //   // e.preventDefault();
  //   var error = jQuery(this).parents("form").find(".error_product_cart");
  //   if (error.length > 0) {
  //     alert("You must discard inappropriate product.");
  //     return false;
  //   } else {
  //     // jQuery(this).parents('form').submit();
  //   }
  // });

  jQuery(document).on("click", ".js-open_modal", function (e) {
    e.preventDefault();

    let modal = jQuery(this).attr("aria-controls");

    jQuery("body").addClass("scroll-lock");
    jQuery("#" + modal).addClass("modal-visible");
  });

  jQuery(document).on("click", ".js-close_modal", function (e) {
    e.preventDefault();

    let modal = jQuery(this).closest(".modal");

    jQuery("body").removeClass("scroll-lock");
    modal.removeClass("modal-visible");
  });

  jQuery(document).on("click", ".js-close_popup", function (e) {
    e.preventDefault();

    let popup = jQuery(this).closest(".popup");

    jQuery("body").removeClass("scroll-lock");
    popup.removeClass("popup-visible");
  });

  $(document).on("click", '[data-action="toggle-tab"]', function () {
    let tab_id = $(this).attr("aria-controls");
    let Section_Tabs = $(this).closest(".Section_Tabs");

    Section_Tabs.find('[data-action="toggle-tab"]')
      .removeClass("is_active")
      .attr("aria-selected", "false");
    Section_Tabs.find(".TabPanel").attr("aria-hidden", "true");

    $(this).addClass("is_active").attr("aria-selected", "true");
    $("#" + tab_id).attr("aria-hidden", "false");
  });


  function renderPageQuickQuoteCart() {
    if ($("body").hasClass("page-quick-quote-cart")) {
      let quote = localStorage.getItem("quote");

      if (quote) {
        quote = JSON.parse(quote);

        // Handlebars.js cart layout
        let source = $("#quotesDetails").html(),
          template = Handlebars.compile(source);

        $("#quotesDetails--list").append(template(quote));

        let sourcePdf = $("#QuotePdf_content").html(),
          templatePdf = Handlebars.compile(sourcePdf);

        $("#quoteDetails_Pdf").append(templatePdf(quote));
      } else {
        $("#quotesDetails--list").append(
          '<div class="cartitems-empty"><div class="cartitems-empty--inner"><p>Your Cart is currently empty</p></div></div>'
        );
      }
    }
  }

  renderPageQuickQuoteCart();

  $(document).on("click", ".js_add_quoteProducts", function (e) {
    e.preventDefault();

    let formData = {
      items: [],
    };

    let quote_products = $(this)
      .closest(".cartitems")
      .find("[data-quote-product]");

    quote_products.each(function (index) {
      let variantId = $(this).attr("data-variant-id"),
        quantity = $(this).find("[data-quote-product-quantity]").val();
      if (typeof variantId !== "undefined" && variantId !== null) {
        formData.items.push({
          quantity: quantity,
          id: variantId,
        });
      }
    });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: formData,
      dataType: "json",
      success: function (cart) {
        window.location.href = "/cart";
      },
      error: function (error) {
        console.error(error);
      },
    });
  });

  $(".quick_quote_cart").on("click", ".js-quoteProduct_remove", function (e) {
    e.preventDefault();

    let quotePrd = $(this).closest("[data-quote-product]"),
      productId = parseInt(quotePrd.attr("data-quote-product")),
      minus_price = 0,
      newQuotePrice = 0,
      minus_priceExGST = 0,
      new_subTotalQuote = 0,
      new_tax = 0;

    let quote_products = localStorage.getItem("quote_products");
    if (quote_products) {
      quote_products = JSON.parse(quote_products);

      quote_products = quote_products.filter(function (prd) {
        return prd.id !== productId;
      });
    }

    let quote = localStorage.getItem("quote");
    if (quote) {
      quote = JSON.parse(quote);
      let quoteproducts = quote.products;

      $.each(quoteproducts, function (index, prd) {
        if (prd.productId == productId) {
          minus_price = prd.totalPrice;
          minus_priceExGST = prd.priceExGST * prd.quantity;
        }
      });
      console.log("1");
      newQuotePrice = quote.quotePrice.quotePrice - minus_price;
      new_subTotalQuote = quote.quotePrice.subTotalQuote - minus_priceExGST;
      new_tax = newQuotePrice - new_subTotalQuote;

      quoteproducts = quoteproducts.filter(function (prd) {
        return prd.productId !== productId;
      });

      quote = {
        products: quoteproducts,
        quotePrice: {
          subTotalQuote: new_subTotalQuote,
          subTotalQuote_with_currency: Shopify.formatMoney(new_subTotalQuote),
          quotePrice: newQuotePrice,
          quotePrice_with_currency: Shopify.formatMoney(newQuotePrice),
          tax: new_tax,
          tax_with_currency: Shopify.formatMoney(new_tax),
        },
      };
    }

    localStorage.setItem("quote_products", JSON.stringify(quote_products));
    localStorage.setItem("quote", JSON.stringify(quote));

    quotePrd.remove();
    $('#generateQuotePdf [data-quote-product="' + productId + '"]').remove();

    $("#quotesDetails--list [data-quote-subtotal]").html(
      Shopify.formatMoney(new_subTotalQuote)
    );
    $("#quotesDetails--list [data-quote-tax]").html(
      Shopify.formatMoney(new_tax)
    );
    $("#quotesDetails--list [data-quote-price-total]").html(
      Shopify.formatMoney(newQuotePrice)
    );

    $("#generateQuotePdf .subTotalQuote.money").html(
      Shopify.formatMoney(new_subTotalQuote)
    );
    $("#generateQuotePdf .taxQuote.money").html(Shopify.formatMoney(new_tax));
    $("#generateQuotePdf .quotePriceTotal.money").html(
      Shopify.formatMoney(newQuotePrice)
    );
  });

  $(".quick_quote_cart").on(
    "change",
    "[data-quote-product-quantity]",
    function (e) {
      e.preventDefault();

      let newQuantity = $(this).val(),
        quotePrd = $(this).closest("[data-quote-product]"),
        this_productId = parseInt(quotePrd.attr("data-quote-product")),
        newQuotePrice = 0,
        new_totalPrice_with_currency = 0,
        new_subTotalQuote = 0;

      let quote = localStorage.getItem("quote");

      if (quote) {
        quote = JSON.parse(quote);

        $.each(quote.products, function (index, prd) {
          if (prd.productId == this_productId) {
            prd.quantity = newQuantity;
            prd.totalPrice = prd.price * newQuantity;
            prd.totalPrice_with_currency = Shopify.formatMoney(
              prd.price * newQuantity
            );
            new_totalPrice_with_currency = Shopify.formatMoney(
              prd.price * newQuantity
            );
          }
          newQuotePrice = newQuotePrice + prd.totalPrice;
          new_subTotalQuote = new_subTotalQuote + prd.quantity * prd.priceExGST;
        });
        console.log("2");

        quote.quotePrice.quotePrice = newQuotePrice;
        quote.quotePrice.quotePrice_with_currency =
          Shopify.formatMoney(newQuotePrice);

        quote.quotePrice.subTotalQuote = new_subTotalQuote;
        quote.quotePrice.subTotalQuote_with_currency =
          Shopify.formatMoney(new_subTotalQuote);

        let taxQuote = newQuotePrice - new_subTotalQuote;
        (quote.quotePrice.tax = taxQuote),
          (quote.quotePrice.tax_with_currency = Shopify.formatMoney(taxQuote));

        localStorage.setItem("quote", JSON.stringify(quote));
        quotePrd
          .find(".cart-item--total .money")
          .html(new_totalPrice_with_currency);
        $("#quotesDetails--list [data-quote-subtotal]").html(
          Shopify.formatMoney(new_subTotalQuote)
        );
        $("#quotesDetails--list [data-quote-tax]").html(
          Shopify.formatMoney(taxQuote)
        );
        $("#quotesDetails--list [data-quote-price-total]").html(
          Shopify.formatMoney(newQuotePrice)
        );

        $(
          '#generateQuotePdf [data-quote-product="' +
          this_productId +
          '"] .totalPrice'
        ).html(new_totalPrice_with_currency);
        $(
          '#generateQuotePdf [data-quote-product="' +
          this_productId +
          '"] .quantity'
        ).html(newQuantity);
        $("#generateQuotePdf .subTotalQuote.money").html(
          Shopify.formatMoney(new_subTotalQuote)
        );
        $("#generateQuotePdf .taxQuote.money").html(
          Shopify.formatMoney(taxQuote)
        );
        $("#generateQuotePdf .quotePriceTotal.money").html(
          Shopify.formatMoney(newQuotePrice)
        );
      }
    }
  );

  $(document).on("click", ".js-saveQuote", function (e) {
    e.preventDefault();

    let form = $(this).closest("form"),
      quoteName = form.find('input[name="quoteName"]').val(),
      modal = $(this).closest(".modal");

    let quote = {
      customerId: form.find('input[name="customerId"]').val(),
      customerEmail: form.find('input[name="customerEmail"]').val(),
      customerName: form.find('input[name="customerName"]').val(),
      quoteName: form.find('input[name="quoteName"]').val(),
      products: [],
      quotePriceTotal: "",
    };

    let temp_quote = localStorage.getItem("quote");

    if (temp_quote) {
      temp_quote = JSON.parse(temp_quote);
    }

    quote.products = JSON.stringify(temp_quote.products);
    quote.quotePriceTotal = temp_quote.quotePrice.quotePrice_with_currency;

    $.ajax({
      type: "POST",
      url: "/apps/requote-custom-app/quote",
      data: quote,
      dataType: "json",
      success: function (result) {
        localStorage.removeItem("quote_products");
        localStorage.removeItem("quote");

        /** Add download function */
        $("body").removeClass("scroll-lock");
        modal.removeClass("modal-visible");
        $("#generateQuotePdf [data-quote-createat]").html(result.data.createAt);
        $("#generateQuotePdf [data-quoteid]").html(result.data.quoteId);
        $("#generateQuotePdf [data-quotename]").html(quoteName);
        convertHTMLtoPDF();
      },
      error: function (error) {
        console.error("Error:", error);
      },
    });
  });

  $("#account_saved_quotes").on(
    "change",
    "[data-quote-product-quantity]",
    function (e) {
      e.preventDefault();

      let newQuantity = $(this).val(),
        this_product = $(this).closest("[data-quote-product]"),
        this_productId = this_product.attr("data-quote-product"),
        this_price = parseInt(
          this_product.find("[data-price]").attr("data-price")
        ),
        products = $(this).closest(".quotesDetails").find("[data-total-price]"),
        new_quotePriceTotal = 0,
        new_subTotalQuote = 0;

      this_product
        .find("[data-total-price]")
        .attr("data-total-price", this_price * newQuantity);
      this_product
        .find("[data-total-price] .money")
        .html(Shopify.formatMoney(this_price * newQuantity));

      products.each(function (index, item) {
        let totalPrice = parseInt($(item).attr("data-total-price"));
        new_quotePriceTotal = new_quotePriceTotal + totalPrice;

        let item_quantity = $(item)
          .closest("[data-quote-product]")
          .find("[data-quote-product-quantity]")
          .val(),
          item_priceExGST = parseInt(
            $(item)
              .closest("[data-quote-product]")
              .find("[data-priceExGST]")
              .attr("data-priceExGST")
          );
        console.log("4");

        new_subTotalQuote = new_subTotalQuote + item_quantity * item_priceExGST;
      });

      let new_tax = new_quotePriceTotal - new_subTotalQuote;

      $(this)
        .closest(".quotesDetails")
        .find("[data-quote-subtotal]")
        .html(Shopify.formatMoney(new_subTotalQuote));
      $(this)
        .closest(".quotesDetails")
        .find("[data-quote-tax]")
        .html(Shopify.formatMoney(new_tax));
      $(this)
        .closest(".quotesDetails")
        .find("[data-quote-price-total]")
        .html(Shopify.formatMoney(new_quotePriceTotal));

      $(
        '#generateQuotePdf [data-quote-product="' +
        this_productId +
        '"] .totalPrice'
      ).html(Shopify.formatMoney(this_price * newQuantity));
      $(
        '#generateQuotePdf [data-quote-product="' +
        this_productId +
        '"] .quantity'
      ).html(newQuantity);

      $("#generateQuotePdf .subTotalQuote.money").html(
        Shopify.formatMoney(new_subTotalQuote)
      );
      $("#generateQuotePdf .taxQuote.money").html(Shopify.formatMoney(new_tax));
      $("#generateQuotePdf .quotePriceTotal.money").html(
        Shopify.formatMoney(new_quotePriceTotal)
      );
    }
  );

  $("#account_saved_quotes").on(
    "click",
    ".js-quoteProduct_remove",
    function (e) {
      e.preventDefault();

      let this_product = $(this).closest("[data-quote-product]"),
        this_productId = this_product.attr("data-quote-product"),
        products = this_product.siblings("[data-quote-product]"),
        quote = $(this).closest(".quotesDetails"),
        new_quotePriceTotal = 0,
        new_subTotalQuote = 0;

      products.each(function (index, item) {
        let totalPrice = parseInt(
          $(item).find("[data-total-price]").attr("data-total-price")
        );
        new_quotePriceTotal = new_quotePriceTotal + totalPrice;

        let item_quantity = $(item).find("[data-quote-product-quantity]").val(),
          item_priceExGST = parseInt(
            $(item).find("[data-priceExGST]").attr("data-priceExGST")
          );
        console.log("5");

        new_subTotalQuote = new_subTotalQuote + item_quantity * item_priceExGST;
      });

      let new_tax = new_quotePriceTotal - new_subTotalQuote;

      quote
        .find("[data-quote-subtotal]")
        .html(Shopify.formatMoney(new_subTotalQuote));
      quote.find("[data-quote-tax]").html(Shopify.formatMoney(new_tax));
      quote
        .find("[data-quote-price-total]")
        .html(Shopify.formatMoney(new_quotePriceTotal));
      this_product.remove();

      $(
        '#generateQuotePdf [data-quote-product="' + this_productId + '"]'
      ).remove();
      $("#generateQuotePdf .subTotalQuote.money").html(
        Shopify.formatMoney(new_subTotalQuote)
      );
      $("#generateQuotePdf .taxQuote.money").html(Shopify.formatMoney(new_tax));
      $("#generateQuotePdf .quotePriceTotal.money").html(
        Shopify.formatMoney(new_quotePriceTotal)
      );
    }
  );

  $(document).on("click", ".js-updateQuote", function (e) {
    e.preventDefault();

    let temp_quote = $(this).closest(".quotesDetails"),
      temp_quoteId = parseInt(temp_quote.attr("data-quote-id"));

    let quote = {
      customerId: temp_quote.find('input[name="customerId"]').val(),
      customerEmail: temp_quote.find('input[name="customerEmail"]').val(),
      customerName: temp_quote.find('input[name="customerName"]').val(),
      quoteName: temp_quote.find('input[name="quoteName"]').val(),
      quoteId: temp_quoteId,
      products: [],
      quotePriceTotal: temp_quote.find("[data-quote-price-total]").text(),
    };

    let products = temp_quote.find("[data-quote-product]"),
      item = {};

    $.each(products, function (index, prd) {
      let temp_price = parseInt($(prd).find("[data-price]").attr("data-price")),
        temp_totalPrice = parseInt(
          $(prd).find("[data-total-price]").attr("data-total-price")
        );
      temp_priceExGST = parseInt(
        $(prd).find("[data-priceExGST]").attr("data-priceExGST")
      );
      console.log("6");

      item = {
        productId: parseInt($(prd).attr("data-quote-product")),
        url: $(prd).find(".cart-item--image-wrapper a").attr("href"),
        productName: $(prd).find(".cart-item--content-title a").text(),
        image: $(prd).find(".cart-item--image-wrapper img").attr("src"),
        variantId: parseInt($(prd).attr("data-variant-id")),
        sku: $(prd).find(".cart-item--sku").text(),
        priceExGST: temp_priceExGST,
        price: temp_price,
        totalPrice: temp_totalPrice,
        quantity: $(prd).find("[data-quote-product-quantity]").val(),
        priceExGST_with_currency: Shopify.formatMoney(temp_priceExGST),
        price_with_currency: Shopify.formatMoney(temp_price),
        totalPrice_with_currency: Shopify.formatMoney(temp_totalPrice),
      };

      quote.products.push(item);
    });

    quote.products = JSON.stringify(quote.products);

    $.ajax({
      type: "POST",
      url: "/apps/requote-custom-app/quote",
      data: quote,
      dataType: "json",
      success: function (result) {
        window.location.reload();
      },
      error: function (error) {
        console.error("Error:", error);
      },
    });
  });

  $(document).on("click", ".js-saveQuote-pdf", function (e) {
    e.preventDefault();

    let form = $(this).closest("form"),
      quoteName = form.find('input[name="quoteName"]').val(),
      modal = $(this).closest(".modal");

    let dataEl = $(this).closest(".cart--section").find("[data-section-data]");
    if (!dataEl) return {};
    let dataHTML = dataEl.attr("data-section-data") || dataEl.html(),
      data = JSON.parse(dataHTML),
      cart = data.cart;

    let quote = {
      customerId: form.find('input[name="customerId"]').val(),
      customerEmail: form.find('input[name="customerEmail"]').val(),
      customerName: form.find('input[name="customerName"]').val(),
      quoteName: form.find('input[name="quoteName"]').val(),
      products: [],
      quotePriceTotal: Shopify.formatMoney(cart.total_price),
    };

    let products = cart.items,
      item = {};

    if (products.length > 0) {
      $.each(products, function (index, prd) {
        item = {
          productId: prd.product_id,
          url: prd.url,
          productName: prd.title,
          image: prd.image,
          variantId: prd.variant_id,
          sku: prd.sku,
          price: prd.price,
          totalPrice: prd.line_price,
          quantity: prd.quantity,
          price_with_currency: Shopify.formatMoney(prd.price),
          totalPrice_with_currency: Shopify.formatMoney(prd.line_price),
        };

        quote.products.push(item);
      });
    }

    quote.products = JSON.stringify(quote.products);

    $.ajax({
      type: "POST",
      url: "/apps/requote-custom-app/quote",
      data: quote,
      dataType: "json",
      success: function (result) {
        $("body").removeClass("scroll-lock");
        modal.removeClass("modal-visible");
        $("#generateQuotePdf [data-quote-createat]").html(result.data.createAt);
        $("#generateQuotePdf [data-quoteid]").html(result.data.quoteId);
        $("#generateQuotePdf [data-quotename]").html(quoteName);
        convertHTMLtoPDF();
      },
      error: function (error) {
        console.error("Error:", error);
      },
    });
  });
});

// Load more
function ScrollExecute() {
  if (
    jQuery(document).height() - 800 <
    jQuery(document).scrollTop() + jQuery(window).height()
  ) {
    scrollNode = jQuery("#AjaxinatePagination").last();
    scrollURL = jQuery("#AjaxinatePagination a").last().attr("href");
    if (scrollNode.length > 0 && scrollNode.css("display") != "none") {
      jQuery.ajax({
        type: "GET",
        url: scrollURL,
        beforeSend: function () {
          scrollNode.hide();
        },
        success: function (data) {
          scrollNode.next().remove();
          var filteredData = jQuery(data).find(
            "#AjaxinateContainer .product-row"
          );

          var checkLastPage = jQuery("#AjaxinatePagination a").last();
          var nextUrl = jQuery(data)
            .find("#AjaxinatePagination a")
            .last()
            .attr("href");
          if (nextUrl) {
            jQuery("#AjaxinatePagination a").last().attr("href", nextUrl);
            scrollNode.show();
          } else {
            scrollNode.hide();
          }
          if (checkLastPage.length != 0) {
            filteredData.appendTo(jQuery("#AjaxinateContainer"));
          }
        },
        dataType: "html",
      });
    }
  }
}

jQuery(document).ready(function () {
  //  jQuery('a').on('click', (e) => {
  //    e.stopPropagation();
  //    console.log(e.target);
  //  })
});

function convertHTMLtoPDF() {
  const { jsPDF } = window.jspdf;

  var doc = new jsPDF("p", "px", [1190, 1683]);
  var pdfjs = document.querySelector("#generateQuotePdf");

  doc.setLineHeightFactor(1.5);

  doc.html(pdfjs, {
    callback: function (doc) {
      doc.save("Quote.pdf");
    },
    x: 0,
    y: 0,
  });
}

//Set Cookies
document.cookie = "Secure_customer_sig=true; secure; path=/";
